// Hook dodania pozycji do oferty – POST /sales-crm/clients/:cid/offers/:oid/positions

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPostSalesCrmOfferPositionPayload {
  productId: number;
  quantity: number;
  productUnitId?: number;
  warehouseId?: number;
}

type IResponse = ICommandResponseSuccess & { id?: number };

const postSalesCrmOfferPosition = (
  clientId: number,
  offerId: string,
  payload: IPostSalesCrmOfferPositionPayload
): Promise<IResponse> => axios.post(`/sales-crm/clients/${clientId}/offers/${offerId}/positions`, payload);

export const usePostSalesCrmOfferPosition = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, IPostSalesCrmOfferPositionPayload>
) =>
  useMutation(
    (payload: IPostSalesCrmOfferPositionPayload) => postSalesCrmOfferPosition(clientId, offerId, payload),
    options
  );
